import { useEffect, useState } from 'react';
import { depots } from '@/shared/donnees';
import { FileAttente, stockageIndexedDb, stockageMemoire, type Operation } from './file-attente';

export type { Geste, Operation, Issue } from './file-attente';
export { cibleDe } from './file-attente';
export { compresserPhoto } from './compression';

/** La file unique de l'appli : IndexedDB quand le navigateur l'offre, la mémoire sinon. */
export const fileAttente = new FileAttente(
  typeof indexedDB === 'undefined' ? stockageMemoire() : stockageIndexedDb,
  () => depots().chantiers,
  undefined,
  () => depots().sav
);

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    void fileAttente.vider();
  });
  /* Au démarrage, ce qui attendait depuis la dernière fois repart. */
  void fileAttente.vider();
}

/** L'état du réseau et de la file, pour les bandeaux de l'appli terrain. */
export function useHorsLigne() {
  const [enLigne, setEnLigne] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine
  );
  const [operations, setOperations] = useState<Operation[]>([]);

  useEffect(() => {
    let actif = true;
    const relire = () => {
      void fileAttente
        .lister()
        .then((ops) => {
          if (actif) setOperations(ops);
        })
        .catch(() => undefined);
    };
    const enLigneOui = () => {
      setEnLigne(true);
    };
    const enLigneNon = () => {
      setEnLigne(false);
    };
    relire();
    const desabonner = fileAttente.sAbonner(relire);
    window.addEventListener('online', enLigneOui);
    window.addEventListener('offline', enLigneNon);
    return () => {
      actif = false;
      desabonner();
      window.removeEventListener('online', enLigneOui);
      window.removeEventListener('offline', enLigneNon);
    };
  }, []);

  return {
    enLigne,
    enAttente: operations.filter((o) => o.refus === undefined),
    refusees: operations.filter((o) => o.refus !== undefined),
  };
}

// ── Ce qu'on garde pour lire sans réseau ─────────────────────────────────────

/** La copie gardée, telle qu'écrite par `ecrireCache` ; à l'appelant de dire ce qu'elle contient. */
export function lireCache(cle: string): { valeur: unknown; le: string } | null {
  try {
    const brut = window.localStorage.getItem(`vla-cache:${cle}`);
    return brut ? (JSON.parse(brut) as { valeur: unknown; le: string }) : null;
  } catch {
    return null;
  }
}

export function ecrireCache(cle: string, valeur: unknown): void {
  try {
    window.localStorage.setItem(
      `vla-cache:${cle}`,
      JSON.stringify({ valeur, le: new Date().toISOString() })
    );
  } catch {
    /* Stockage plein : l'appli marche quand même, en ligne. */
  }
}
